import { ReactElement, useCallback } from 'react';
import { PetitionsDetailResponse } from '../../../types';
import { createFetchContext } from '../../../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../../../components/Info/DisplayError';
import Loading from '../../../../../../../../components/Info/Loading';
import { fetchPetitionDetaiAndFiles } from '../../../hooks/useActions';

export interface PetitionsDetailProps<T> {
  petitionId: number;
  children: (props: { data: T }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  {
    petitionId: number;
  },
  PetitionsDetailResponse
>();

export const PetitionsDetailLoaderConsumer = FetchConsumer;

export function PetitionsDetailLoader({
  petitionId,
  children,
}: PetitionsDetailProps<PetitionsDetailResponse>) {
  const request = useCallback(() => {
    return fetchPetitionDetaiAndFiles(petitionId);
  }, [petitionId]);
  return (
    <FetchProvider
      request={request}
      defaultQuery={{ petitionId }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
